module.exports = __webpack_public_path__ + "static/img/polymer-resin_256.535dff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/polymer-resin_256.png
// module id = pzId
// module chunks = 0